export const validateHTML = (value: unknown): string | true => {
  const stringValue = String(value || '').trim();

  if (!stringValue) {
    return 'Script is required';
  }

  // Must contain at least one complete HTML tag
  if (!/<[^>]+>/.test(stringValue)) {
    return 'Script must contain valid HTML tags (e.g., <script>...</script>)';
  }

  // Check for tag not closed with >
  if (/<[^>]*$/.test(stringValue)) {
    return 'Invalid HTML: Tag is not properly closed with ">"';
  }

  // Extract and validate all tags
  const allTags = [
    ...stringValue.matchAll(/<\/?([a-zA-Z][a-zA-Z0-9]*)[^>]*>/g),
  ];
  const selfClosingTags = new Set([
    'br',
    'hr',
    'img',
    'input',
    'link',
    'meta',
    'area',
    'base',
    'col',
    'embed',
    'param',
    'source',
    'track',
    'wbr',
  ]);
  const tagStack: string[] = [];

  for (const match of allTags) {
    const fullTag = match[0];
    const tagName = match[1].toLowerCase();
    const isClosing = fullTag.startsWith('</');
    const isSelfClosing =
      fullTag.endsWith('/>') || selfClosingTags.has(tagName);

    if (isClosing) {
      // Closing tag
      if (tagStack.length === 0) {
        return `Invalid HTML: Closing tag </${tagName}> has no matching opening tag`;
      }
      const lastOpen = tagStack.pop();
      if (lastOpen !== tagName) {
        return `Invalid HTML: Expected </${lastOpen}> but found </${tagName}>`;
      }
    } else if (!isSelfClosing) {
      tagStack.push(tagName);
    }
  }

  // Check for unclosed tags
  if (tagStack.length > 0) {
    return `Invalid HTML: Missing closing tag </${tagStack[tagStack.length - 1]}>`;
  }

  // Validate URLs in src/href attributes
  const srcMatches = stringValue.matchAll(/(?:src|href)=["']([^"']+)["']/gi);
  for (const match of srcMatches) {
    const url = match[1];
    try {
      new URL(url);
    } catch {
      return `Invalid URL: ${url}`;
    }
  }

  return true;
};
